<template lang="pug">
  .layout
    y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card(flat)
        v-card-title.pa-4
          v-btn.mr-4(text icon small @click="closeDialog")
            eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary700" width="22" height="22")
          div.h6.primary500--text {{ $t('ongoing.title') }}
        v-card-text.basic300.pa-4
          //- Arranged
          template(v-if="!arranged")
            ongoing-empty(groupName="Arranged")
          template(v-else)
            ongoing-header(groupName="Arranged")
            v-card.mb-4(flat)
              ongoing-item(v-for="(item, itemIndex) in arranged" :key="item.id" closable :item="item" :showDivider="itemIndex !== arranged.length-1" @dismiss="handleDismissItem")
                template(#additionalAction)
                  v-divider.basic300.mx-5
                  div.d-flex.align-center.justify-space-around.py-2
                    v-btn.button-Aa-small.px-0(text color="transparent" small @click="selectedItem = item; openTrackingLink()")
                      eva-icon.mb-n1(name="map-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
                      div.basic700--text.ml-2 {{ $t('arranged.track') }}
                    v-btn.button-Aa-small.px-0(text color="transparent" small @click="selectedItem = item; shareTrackingLinkToWA(selectedItem.fulfilment.title, selectedItem.lead_pid)")
                      v-icon(color="basic700" size="16") mdi-whatsapp
                      div.basic700--text.ml-2 {{ $t('arranged.share') }}
                    v-btn.button-Aa-small.px-0(text color="transparent" small @click="selectedItem = item; copyTrackingNo()" v-clipboard:copy="getCopyTrackingNo()")
                      eva-icon.mb-n1(name="copy-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
                      div.basic700--text.ml-2 {{ $t('arranged.copy') }}
          //- Failed
          template(v-if="!failed")
            ongoing-empty(groupName="Failed")
          template(v-else)
            ongoing-header(groupName="Failed")
              template(#additionalText)
                span.text-decoration-underline.clickable(@click="ongoingFailedReasonDialog = true") {{ $t('failed.why') }}?
            v-card.mb-4(flat)
              ongoing-item(v-for="(item, itemIndex) in failed" :key="item.id" closable :item="item" :showDivider="itemIndex !== failed.length-1" @dismiss="handleDismissItem")
                template(#additionalButton)
                  v-btn.danger500(small dark depressed :loading="isFetchingRearrange" @click="selectedItem = item; rearrangeShipment()")
                    .button-AA-tiny.basic100--text {{ $t('failed.retry') }}
                template(#additionalSpace)
                  div.c1.danger400--text.px-4.pb-3 {{ $t('failed.error') }} : {{ errorRemark(item.extra_data.error.remark) }}
          //- Matching
          template(v-if="!matching")
            ongoing-empty(groupName="Matching")
          template(v-else)
            ongoing-header(groupName="Matching")
            v-card.mb-4(flat)
              ongoing-item(v-for="(item, itemIndex) in matching" :key="item.id" :item="item" :showDivider="itemIndex !== matching.length-1")
                template(#additionalButton)
                  v-btn(small text @click="selectedItem = item; openCancelOrderDialog = true")
                    .button-Aa-tiny.primary400--text {{ $t('matching.cancel') }}
    .dialogs
      confirm-cancel-local-delivery(v-if="openCancelOrderDialog" :open.sync="openCancelOrderDialog" :orderNumber="selectedItem.lead_rid" @cancelOrder="cancelOrder")
      cancel-local-delivery-error(v-if="openCancelOrderErrorDialog" :open.sync="openCancelOrderErrorDialog" :error="errorCancel")
      //- tracking-view(v-if="openTrackingViewDialog" :open.sync="openTrackingViewDialog" :link="selectedItem.tracking")
      arrange-shipment(v-if="openArrangeShipmentDialog" :open.sync="openArrangeShipmentDialog" :parentLead.sync="selectedLead" :parentYezzaShipping.sync="selectedYezzaShipping" :skipArrangingRiderScene="true" @setOngoingInterval="setOngoingInterval")
      ongoing-failed-reason(v-if="ongoingFailedReasonDialog" :open.sync="ongoingFailedReasonDialog")
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import OngoingEmpty from '@/components/dialogs/yezzashipping/ongoing/OngoingEmpty.vue'
import OngoingHeader from '@/components/dialogs/yezzashipping/ongoing/OngoingHeader.vue'
import OngoingItem from '@/components/dialogs/yezzashipping/ongoing/OngoingItem.vue'
import OngoingFailedReason from '@/components/dialogs/yezzashipping/ongoing/OngoingFailedReason.vue'
// NOTE: Not in use due to issue with unresponsive button in iframe
// import TrackingView from '@/components/dialogs/yezzashipping/TrackingView.vue'
import ConfirmCancelLocalDelivery from '@/components/dialogs/yezzashipping/ConfirmCancelLocalDelivery.vue'
import CancelLocalDeliveryError from '@/components/dialogs/yezzashipping/CancelLocalDeliveryError.vue'
import ArrangeShipment from '@/components/dialogs/yezzashipping/ArrangeShipment.vue'

export default {
  name: 'Ongoing',
  components: {
    OngoingEmpty,
    OngoingHeader,
    OngoingItem,
    OngoingFailedReason,
    ConfirmCancelLocalDelivery,
    CancelLocalDeliveryError,
    ArrangeShipment
  },
  props: {
    open: {
      type: Boolean
    }
  },
  data() {
    return {
      ongoingFailedReasonDialog: false,
      ongoingInterval: null,
      selectedItem: null,
      openTrackingViewDialog: false,
      openCancelOrderDialog: false,
      openArrangeShipmentDialog: false,
      selectedLead: null,
      selectedYezzaShipping: null,
      isFetchingRearrange: false,
      errorCancel: null,
      openCancelOrderErrorDialog: false
    }
  },
  mounted() {
    // Fetch ongoing first before setting interval
    this.fetchOngoing()
    // Then set interval for each update
    this.setOngoingInterval()
  },
  beforeDestroy() {
    this.stopOngoingInterval()
  },
  computed: {
    ...mapState('riders', {
      ongoingIntervalTime: state => state.intervalTime
    }),
    ...mapGetters({
      company: 'getCompany',
      groupedOngoingData: 'riders/getGroupedOngoingData'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(val) {
        this.$store.commit('riders/updateOpenOngoingDialog', val)
      }
    },
    arranged() {
      return this.groupedOngoingData['arranged'] || null
    },
    failed() {
      return this.groupedOngoingData['failed'] || null
    },
    matching() {
      return this.groupedOngoingData['matching'] || null
    }
  },
  watch: {
    matching(newValue, oldValue) {
      // Bypass
      if (!oldValue) {
        return
      }
      // Update data only when changing
      if (!newValue || newValue.length !== oldValue.length) {
        this.$store.commit('riders/updateRefetchAllOrders', true)
        this.fetchCompany()
      }
    }
  },
  methods: {
    ...mapActions(['showMessage', 'updateCompany']),
    closeDialog() {
      this.showModal = false
    },
    fetchOngoing() {
      const params = { company: this.company.id }
      this.$axios
        .get('/shipping/yezzashipping/ongoing', { params })
        .then(resp => {
          this.$store.commit('riders/updateOngoingData', resp.data)
          // Stop ongoing interval if no matching data returned
          if (!this.matching) {
            this.stopOngoingInterval()
          }
        })
        .catch(() => {})
    },
    setOngoingInterval() {
      this.ongoingInterval = setInterval(() => {
        this.fetchOngoing()
      }, this.ongoingIntervalTime)
    },
    stopOngoingInterval() {
      clearInterval(this.ongoingInterval)
    },
    cancelOrder() {
      this.$axios
        .get(`/shipping/yezzashipping/${this.selectedItem.id}/cancel`)
        .then(() => {
          this.$store.commit('riders/updateRefetchOneOrder', this.selectedItem.lead_pid)
          this.$store.commit('riders/dismissOngoingData', this.selectedItem)
          this.showMessage(['success', this.$t('cancel_success')])
        })
        .catch(error => {
          // Handling error from error code
          if (error.response) {
            const { data } = error.response
            if (data.code) {
              this.errorCancel = data
              this.openCancelOrderErrorDialog = true
              return
            }
          }
          // Everything else
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.openCancelOrderDialog = false
        })
    },
    async rearrangeShipment() {
      try {
        this.isFetchingRearrange = true
        const allFetching = [this.fetchOneLead(), this.fetchYezzaShipping()]
        await Promise.all([...allFetching])
        this.openArrangeShipmentDialog = true
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
      this.isFetchingRearrange = false
    },
    fetchOneLead() {
      return this.axios.get(`/leads/${this.selectedItem.lead_pid}`).then(resp => {
        this.selectedLead = resp.data
      })
    },
    fetchYezzaShipping() {
      return this.$axios.get(`/shipping/yezzashipping/${this.selectedItem.id}`).then(resp => {
        this.selectedYezzaShipping = resp.data
      })
    },
    handleDismissItem(item) {
      const params = { dismiss: item.id }
      this.$axios
        .get('/shipping/yezzashipping/ongoing', { params })
        .then(() => {
          this.$store.commit('riders/dismissOngoingData', item)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    copyTrackingNo() {
      this.showMessage(['success', this.$t('tracking.copy')])
    },
    getCopyTrackingNo() {
      return this.selectedItem ? this.selectedItem.tracking : ''
    },
    shareTrackingLinkToWA(shipping_name, lead_pid) {
      const divider = '%0a-----------------------------------%0a'
      // const message = `Hi, we have arranged your delivery with ${encodeURIComponent(shipping_name)}. You can track its real-time location here:%0ahttps://track.yezza.io/track/${lead_pid}${divider}`
      const message = this.$t('tracking.share_message', {
        shippingName: encodeURIComponent(shipping_name),
        leadPid: lead_pid,
        divider
      })
      window.open(`https://api.whatsapp.com/send?text=${message}&phone=${this.selectedItem.receiver_address.phone}`)
    },
    errorRemark(remark) {
      switch (remark) {
        case 'Assigning driver timeout':
          return this.$t('failed.error_remark.timeout')

        default:
          return this.$t('failed.error_remark.default')
      }
    },
    fetchCompany() {
      this.$axios
        .get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
    },
    openTrackingLink () {
      window.open(this.selectedItem.tracking, '_blank')
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "ongoing": {
      "title": "Ongoing"
    },
    "arranged": {
      "track": "Track",
      "share": "Share",
      "copy": "Copy"
    },
    "failed": {
      "retry": "Retry",
      "why": "Why",
      "error": "Error",
      "error_remark": {
        "timeout": "No rider found. Please try again",
        "default": "Unable to proceed. Please try again"
      }
    },
    "matching": {
      "cancel": "Cancel"
    },
    "tracking": {
      "copy": "Tracking number copied to your clipboard",
      "share_message": "Hi, we have arranged your delivery with {shippingName}. You can track its real-time location here:%0ahttps://track.yezza.io/track/{leadPid}{divider}"
    },
    "cancel_success": "Order cancelled"
  },
  "id": {
    "ongoing": {
      "title": "Sedang berlangsung"
    },
    "arranged": {
      "track": "Track",
      "share": "Bagikan",
      "copy": "Salin"
    },
    "failed": {
      "retry": "Coba Lagi",
      "why": "Sebab",
      "error": "Error",
      "error_remark": {
        "timeout": "Tiada rider dijumpai. Sila coba lagi",
        "default": "Sila coba lagi"
      }
    },
    "matching": {
      "cancel": "batal"
    },
    "tracking": {
      "copy": "Nomor pelacakan sudah disalin",
      "share_message": "Hai, kami telah mengatur pengiriman kamu dengan {shippingName}. kamu dapat melacak lokasi real-time di sini:%0ahttps://track.yezza.io/track/{leadPid}{divider}"
    },
    "cancel_success": "Order sudah dihapus"
  }
}
</i18n>